'use client';

import { Chip as HeroChip } from '@heroui/react';
import { ReactNode } from 'react';

export interface ChipProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'soft';
  color?: 'default' | 'accent' | 'success' | 'warning' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}

export const Chip = ({
  children,
  variant = 'secondary',
  color = 'default',
  size = 'md',
}: ChipProps) => {
  return (
    <HeroChip variant={variant} color={color} size={size}>
      <HeroChip.Label>{children}</HeroChip.Label>
    </HeroChip>
  );
};
